// First Med Individual / Family Medical — approved rates 2025
// Source: "First Med-Approve rates" sheet, Individual Product Write-Up.xlsx
export const individualMedicalRatesData = {
    product: "individual_medical",
    version: "2025.1",
    // Inpatient: annual premium per member type, by age band and limit index.
    // Limits in ascending order: 500k, 1M, 2M, 3M, 5M (per family).
    // Children are not age-banded — same child rate regardless of principal's age.
    inpatient: {
        limits: [500000, 1000000, 2000000, 3000000, 5000000],
        bands: [
            {
                minAge: 19,
                maxAge: 30,
                principal: [17492.25, 22038, 27128.25, 30432, 33501],
                spouse: [15042.75, 18952.5, 23329.5, 26171.25, 28810.5],
                child: [11021.25, 13885.5, 17092.5, 19174.5, 21108],
            },
            {
                minAge: 31,
                maxAge: 40,
                principal: [18637.5, 23481, 28904.25, 32424.75, 35694],
                spouse: [16027.5, 20193, 24857.25, 27885, 30696.75],
                child: [11021.25, 13885.5, 17092.5, 19174.5, 21108],
            },
            {
                minAge: 41,
                maxAge: 50,
                principal: [22411.5, 28236, 34757.25, 38991, 42922.5],
                spouse: [19273.5, 24282.75, 29891.25, 33531.75, 36912.75],
                child: [11021.25, 13885.5, 17092.5, 19174.5, 21108],
            },
            {
                minAge: 51,
                maxAge: 65,
                principal: [24490.5, 30855, 37982.25, 42608.25, 46904.25],
                spouse: [21061.5, 26535, 32664, 36642, 40337.25],
                child: [11021.25, 13885.5, 17092.5, 19174.5, 21108],
            },
        ],
    },
    // Outpatient: annual premium per person, age-banded by principal's age.
    // Same rate for principal and spouse; children always use the under-30 band.
    // Limits in ascending order: 50k, 75k, 100k, 150k, 200k (per person).
    outpatient: {
        limits: [50000, 75000, 100000, 150000, 200000],
        bands: [
            { minAge: 0, maxAge: 30, premiums: [22701, 26802.59, 29149.23, 36328.90, 38955.03] },
            { minAge: 31, maxAge: 40, premiums: [28376.25, 33503.87, 36437.17, 45410.81, 48694.10] },
            { minAge: 41, maxAge: 50, premiums: [34051.5, 40203.88, 43723.85, 54492.72, 58431.91] },
            { minAge: 51, maxAge: 65, premiums: [39726.75, 46905.16, 51011.79, 63574.63, 68170.98] },
        ],
    },
    // Maternity: annual premium per family (flat, not age-banded).
    // Limits in ascending order: 75k, 100k, 120k, 150k, 200k.
    maternity: {
        limits: [75000, 100000, 120000, 150000, 200000],
        premiums: [23620, 26976, 28879, 34359, 44672],
    },
    // Dental: annual premium per person (age-independent).
    // Dental and Optical must be purchased together as a package.
    // Limits in ascending order: 7.5k, 10k, 20k, 30k, 40k.
    dental: {
        limits: [7500, 10000, 20000, 30000, 40000],
        premiums: [2048.4, 2731.2, 5462.4, 8193.6, 10924.8],
    },
    // Optical: annual premium per person (age-independent).
    // Must be purchased together with Dental.
    // Limits in ascending order: 7.5k, 10k, 20k, 30k, 40k.
    optical: {
        limits: [7500, 10000, 20000, 30000, 40000],
        premiums: [2276, 3034, 6068, 9102, 16182],
    },
    stampDutyKes: 40,
};
